
<el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading">
  <div class="screen-clients-loading" v-if="loading">
    {{ loadingInfo }}<br>
    {{ loadingInfo1 }}<br>
    {{ loadingInfo2 }}
  </div>
  <div class="clients-panel">
    <div class="clients-panel-container">
      <el-row class="black-inputs">
        <el-col :span="8">
          <el-input v-model="inputSearch" placeholder="Rechercher par mots clés">
            <i class="el-icon-search el-input__icon" slot="prefix"></i>
          </el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-button class="dark" type="primary" @click="showImportContact = !showImportContact">Importer des
            contacts</el-button>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-button :loading=exportIsLoading class="dark" type="primary" @click="exportClients">Exporter mes
            contacts</el-button>
        </el-col>
      </el-row>
      <el-row v-if="showImportContact">
        <el-col class="clients-importer" :span="15" :offset="9">
          <label for="csv_file">Choisir un fichier</label>
          <input type="file" id="csv_file" name="csv_file" @change="loadCSV($event)">
          <span v-if="parse_csv.length > 0">
            <span class="clients-importer-ongoing">Vous allez importer {{ parse_csv.length }} contacts</span>
            <el-button class="green" @click="importContact">Importer</el-button>
            <div class="clients-importer-format">
              <label>Format du fichier</label>
              <el-radio v-model="importType" label="guestonline">GuestOnline</el-radio>
              <el-radio v-model="importType" label="resaninja">resa.ninja</el-radio>
            </div>
          </span>
        </el-col>
      </el-row>
      <el-row class="black-inputs">
        <el-col :span="8" :offset="8" v-if="this.selection.length > 0 && !addTagDisplay">
          <el-select v-model="tagsSelected" multiple placeholder="Attribuer un label à la sélection">
            <el-option v-for="t in getAllTags" :key="t.value" :label="t.text" :value="t.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" :offset="1" v-if="tagsSelected.length > 0">
          <el-button type="primary" @click="applyTag">Attribuer</el-button>
        </el-col>
        <el-col :span="7" :offset="17" v-if="!addTagDisplay && this.selection.length === 0">
          <el-button class="dark" type="primary" @click="addTagDisplay = true">Ajouter un label</el-button>
        </el-col>
        <el-col class="screen-clients-addTag" :span="24" v-if="addTagDisplay">
          <el-col :span="8">
            <el-input v-model="inputNewTag" placeholder="Saisissez le nouveau label"></el-input>
          </el-col>
          <el-col :span="2" :offset="1">
            <el-color-picker v-model="tagColor"></el-color-picker>
          </el-col>
          <el-col :span="6">
            <el-button class="dark" type="primary" @click="closeAddTag">Annuler</el-button>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-button type="primary" @click="addNewTag">Valider</el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="black-inputs">
        <el-col :span="24" class="screen-clients">
          <el-table ref="multipleTable" :data="getDataGridClients" @sort-change="sortByName"
            @selection-change="handleSelectionChange" @filter-change="handleFilterChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="Nom" sortable="custom" width="180">
            </el-table-column>
            <el-table-column prop="prenom" label="Prénom" sortable="custom" width="180">
            </el-table-column>
            <el-table-column prop="tel" label="Téléphone" width="180">
              <template slot-scope="scope">
                {{ formatPhone(scope.row.tel) }}
              </template>
            </el-table-column>
            <el-table-column prop="tags" label="Label" :filters="getAllTags" filter-placement="bottom-end">
              <template slot-scope="scope">
                <client-tag v-for="tag in scope.row.tags" :key="tag" :idTag="tag" :deletable="false"
                  :cid="scope.row.cid"></client-tag>
              </template>
            </el-table-column>
            <el-table-column label="Edition" width="140">
              <template slot-scope="scope">
                <el-button class="dark" type="primary" @click="editClientInfos(scope.row.cid)">Editer</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :total="getTotalClients"
              :current-page="getCurrentPage" @current-change="current_change">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-container>
